import Hash from '@components/Icons/Hash';
import * as ApiModels from '@typings/api-models';
import BaseAnswer from './BaseAnswer';
import s from '../QuestionAndAnswer.module.scss';

type Props = {
  field: ApiModels.FormResponseNumberField;
};

const NumberAnswer: React.FC<Props> = ({ field: { answer } }) => (
  <div className={s.answer}><Hash weight='regular' /><BaseAnswer answer={answer === null ? null : answer.toString()} /></div>
);

export default NumberAnswer;
